export default __webpack_public_path__ + "static/taskdefinition10-07b28aa6831f084e84b115a42bdd689c.png";